import { useStore } from '@store';
import { writeTheme } from 'src/helpers/theme';
import cs from 'classnames';
import styles from './index.module.scss';

const ToggleStory = () => {
  const { theme, setTheme } = useStore();

  const handleTheme = (e: React.MouseEvent<HTMLElement>) => {
    if (theme === 'night') {
      setTheme('day');
      writeTheme('day');
    } else {
      writeTheme('night');
      setTheme('night');
    }
    e.preventDefault();
  };

  return (
    <div
      className={cs([
        styles['toggle_bg'],
        theme === 'day' ? styles['night'] : '',
      ])}
      onClick={(e) => handleTheme(e)}>
      <div className={styles['toggle']}></div>
    </div>
  );
};

export default ToggleStory;
